import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
} from 'react-router-dom';
import SelectSearch, {useSelect} from 'react-select-search';

const FolderList = ({folders}) => {
  let history = useHistory();
  const onSelect = (val) => {
    history.push(`/folder/${val}`);
  };
  return (
    <div className="sds-wrapper">
      {folders.length > 0 && (
        <>
          <h2>Select a Country</h2>
          <SelectSearch
            options={folders}
            value=""
            autoComplete="on"
            autofocus={true}
            search={true}
            className="sds-search-box"
            placeholder="-- Select Country --"
            onChange={onSelect}
          />
        </>
      )}
    </div>
  );
};

export default FolderList;
